import React from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as UploadCloud } from '../../assets/uploadCloud.svg'
import './DropzonePlaceHolder.scss'
import { FormHelperText } from '@material-ui/core'

export const DropzonePlaceHolder = ({ mainText, helperText = 'Click to upload PNG, JPG or GIF' }) => {
  return (
    <div className="container">
      <FlexView vAlignContent={'center'}>
        <div className="upload-cloud">
          <UploadCloud className="medium-icon" />
        </div>
      </FlexView>
      <FlexView vAlignContent={'center'}>
        <div className="lightgrayblue">
          <FlexView vAlignContent={'center'} className="endoresment-text">
            <div className="text-small main-text poppins-bold">{mainText ? mainText : 'Please upload a file'}</div>
          </FlexView>
          <FormHelperText className="poppins-regular">{helperText}</FormHelperText>
        </div>
      </FlexView>
    </div>
  )
}
